import { Action } from 'redux';

export enum ActionTypes {
    LOAD_START = '@@paidNewslettersTerms/LOAD_START',
    LOAD_SUCCESS = '@@paidNewslettersTerms/LOAD_SUCCESS',
    LOAD_ERROR = '@@paidNewslettersTerms/LOAD_ERROR',
    
    UPDATE_START = '@@paidNewslettersTerms/UPDATE_START',
    UPDATE_SUCCESS = '@@paidNewslettersTerms/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@paidNewslettersTerms/UPDATE_ERROR',

    MODIFY_START = '@@paidNewslettersTerms/MODIFY_START',
    MODIFY_SUCCESS = '@@paidNewslettersTerms/MODIFY_SUCCESS',
    MODIFY_ERROR = '@@paidNewslettersTerms/MODIFY_ERROR',
}

export type PaidNewslettersTermsPayload = {
    terms: string;
    isDefault?: boolean;
}

export interface PaidNewslettersTermsLoadAction extends Action {
    type: ActionTypes.LOAD_START;
}
export interface PaidNewslettersTermsLoadSuccessAction extends Action {
    type: ActionTypes.LOAD_SUCCESS;
    payload: PaidNewslettersTermsPayload;
}
export interface PaidNewslettersTermsLoadErrorAction extends Action {
    type: ActionTypes.LOAD_ERROR;
}

export interface PaidNewslettersTermsUpdateAction extends Action {
    type: ActionTypes.UPDATE_START;
    payload: PaidNewslettersTermsPayload;
}
export interface PaidNewslettersTermsUpdateSuccessAction extends Action {
    type: ActionTypes.UPDATE_SUCCESS;
    payload: PaidNewslettersTermsPayload;
}
export interface PaidNewslettersTermsUpdateErrorAction extends Action {
    type: ActionTypes.UPDATE_ERROR;
}


export interface PaidNewslettersTermsModifySuccessAction extends Action {
    type: ActionTypes. MODIFY_SUCCESS;
    payload: PaidNewslettersTermsPayload;
}
export interface PaidNewslettersTermsModifyErrorAction extends Action {
    type: ActionTypes. MODIFY_ERROR;
}

export interface PaidNewslettersTermsState extends PaidNewslettersTermsPayload {
    isLoading?: boolean,
    isLoaded?: boolean,
    isError?: boolean,
}